<section [ngClass]="containerClasses()"
         id="rootInterface">

    <div *ngIf="canDisplayMenus$ | async"
         [ngClass]="{'-is-closed': isLayoutNavClosed}"
         class="kal-layout__navigation">
        <!-- quand on réduit le menu, on cache l'overlay des sous menus -->
        <a (click)="layoutNav.closeMenu() ;layoutNavToggle()"
           [ngClass]="{'-is-closed': isLayoutNavClosed,  '-is-submenu-open': layoutNav?.isSubMenuOpen$ | async }"
           class="slideButton"
           [class.slideButton--isBaseTest]="isBaseTest">
            <kal-icon>chevron_left</kal-icon>
        </a>
        <app-layout-nav #layoutNav></app-layout-nav>
    </div>


    <div class="kal-layout__wrapper" [kalLoading]="layoutWrapperLoading$ | async">

        <div class="kal-layout__content" cdk-scrollable>

            <div *ngIf="(activatedMenusList$| async | arrayNotEmpty) && !isHomeActive"
                 class="gup-C-filAriane">

                <a *ngFor="let activatedMenu of activatedMenusList$ | async | slice:0:-1; first as first"
                   (click)="openMenu(activatedMenu)">

                    {{ !first ? '>' : '' }} {{ activatedMenu.Libelle }}

                </a>

            </div>

            <router-outlet name="content"></router-outlet>
        </div>

        <div class="kal-layout__focus">
            <router-outlet name="focus"></router-outlet>
        </div>

    </div>


</section>
